import React from "react";

interface PrimaryButtonProps {
    href: string;
    children: React.ReactNode;
    onClick?: () => void;
    target?: string;
    rel?: string;
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({href, children, onClick, target, rel}) => {
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (onClick) {
            e.preventDefault();
            onClick();
        }
    };

    return (
        <a href={href} className="cta-button primary click-anim" onClick={handleClick} target={target} rel={rel}>
            {children}
        </a>
    );
};